export const DIALOG_IDS = {
  RollupPlans: 'rollup-plans',
  RollupConfirm: 'rollup-confirm',
  RollupTestnetProve: 'rollup-testnet-prove',
  RollupPay: 'rollup-pay',
  RollupDeposit: 'rollup-deposit',
  RollupDelete: 'rollup-delete',
  CoretimeProvide: 'rollup-coretime-provide',
  RollupRPCEndpoints: 'rollup-RPC-endpoints',
  RollupBridge: 'rollup-bridge',
  ExtendedRollupTestnet: 'extended-rollup-testnet',
  PlanCancel: 'plan-cancel',
  AccountDelete: 'account-delete',
  BillingSuccess: 'billing-success',
  BillingFailed: 'billing-failed',
  ExplorerSettings: 'explorer-settings',
  CancelRollupDeploymentConfirm: 'cancel-rollup-deployment-confirm',
  ConfirmViaTelegram: 'confirm-via-telegram',
  ConfirmViaSlack: 'confirm-via-slack',
};
